import MultiCheckboxField from './multicheckbox'

export default MultiCheckboxField


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit-fields/src/components/multicheckbox/index.js
// module id = null
// module chunks = 